import Vue from 'vue';
import { formatDistanceToNow } from 'date-fns';
import getFnsLocale from '~/lib/dateFnsLocale';

export default Vue.filter('daysDistance', (value, dateFormat, language) => {
  if (value) {
    const options = {
      addSuffix: true,
      ...getFnsLocale(language),
    };
    return `${formatDistanceToNow(new Date(value), options)}`;
  }
  return '';
});
